var FooterModule = (function () {
    function FooterModule() {
    }
    return FooterModule;
}());
export { FooterModule };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/footer/footer.module.ts.pre-build-optimizer.js